import React from 'react';

const defaultRights = {
  isReadOnly: true,
  isAdmin: false,
  loaded: false
};

export const RightsContext = React.createContext(defaultRights);
